export enum ProductTypeRequest {
  Food = "food",
  Market = "market",
  Shop = "shop",
  Service = "service",
}
